import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import App from './App.vue'
import '@vue/repl/style.css'
import 'vuetify/styles'
import semver from 'semver'

// @ts-expect-error Custom window property
window.VUE_DEVTOOLS_CONFIG = {
  defaultSelectedAppId: 'repl'
}

const vuetify = createVuetify({
  theme: { defaultTheme: 'dark' }
})

const MINIMUM_VUE_VERSION = '3.2.9' // https://github.com/vuejs/core/issues/2154
const MINIMUM_VUETIFY_VERSION = '3.0.0-alpha.11' // First with esm build
const MINIMUM_VUETIFY_NIGHTLY_VERSION = '3.0.0-next-20210831.0'

Promise.all([
  fetchVersionsFromNpm('vue', MINIMUM_VUE_VERSION),
  fetchVuetifyVersions(true),
  fetchVuetifyVersions(false),
]).then(([vueVersions, vuetifyNightlyVersions, vuetifyVersions]) => {
  createApp(App)
    .use(vuetify)
    .provide('versions', {
      vue: vueVersions,
      vuetify: vuetifyVersions,
      vuetifyNightly: vuetifyNightlyVersions,
    })
    .mount('#app')
})

async function fetchVersionsFromNpm (pkg: string, minimumVersion: string): Promise<string[]> {
  try {
    const res = await fetch(`https://registry.npmjs.org/${pkg}`, {
      headers: {
        Accept: 'application/vnd.npm.install-v1+json'
      }
    })

    const json: { versions: Record<string, { version: string }>} = await res.json()

    return Object.keys(json.versions)
      .filter(version => semver.gte(version, minimumVersion))
      .reverse()
  } catch (err) {
    console.error(err)
    return []
  }
}

async function fetchVuetifyVersions (nightly: boolean) {
  return nightly ? fetchVersionsFromNpm('@vuetify/nightly', MINIMUM_VUETIFY_NIGHTLY_VERSION) : fetchVersionsFromNpm('vuetify', MINIMUM_VUETIFY_VERSION)
}
